var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Oops! Page not found")]),_c('p',[_vm._v("Sorry, but the page you are looking for does not exist.")]),_c('v-btn',{attrs:{"href":"/"}},[_vm._v("Go back to the home page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }